import { MDCRipple } from '@material/ripple';
import { addClass } from '../utils/add-class';
import { isInternetExplorer } from '../utils/is-internet-explorer';
import { loopThroughElements } from '../utils/loop-through-elements';
import { removeClass } from '../utils/remove-class';

export class MembershipCard {
    private static clickableCardCssClass = 'membership-card--clickable';
    public static cssClass = 'membership-cards';
    private rootElement: HTMLElement;
    private popout: Window;

    constructor(rootElement: HTMLElement) {
        this.rootElement = rootElement;
        this.bindEvents();
    }

    private bindEvents = (): void => {
        loopThroughElements(this.rootElement.getElementsByClassName(MembershipCard.clickableCardCssClass), el => {
            MDCRipple.attachTo(el);
            const overlay = el.nextElementSibling as HTMLElement;
            const shade = overlay.getElementsByClassName('membership-card__shade')[0] as HTMLElement;
            el.addEventListener('click', (event: MouseEvent): void => {
                addClass(overlay, 'active');
            });
            shade.addEventListener('click', (event: MouseEvent): void => {
                removeClass(overlay, 'active');
            })
            const printButton = overlay.getElementsByTagName('button')[0] as HTMLButtonElement;
            printButton.addEventListener('click', (event: MouseEvent) => this.printCard(overlay));
        });
        window.addEventListener('beforeunload', this.closePopout);
    };

    private printCard = (overlay: HTMLElement): void => {
        console.log('printing card for', overlay);

        const isAbsolute = (url: string): boolean => /^https?:\/\//i.test(url);
        this.closePopout();
        this.popout = window.open('', 'PrintCard', `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=740,height=480`);

        const card = this.popout.document.createElement('div');
        const referenceCard = overlay.getElementsByClassName('membership-card')[0] as HTMLElement;
        card.innerHTML = referenceCard.outerHTML; // can't just use cloneNode because IE is dumb

        loopThroughElements(card.getElementsByTagName('img'), el => {
            const img = el as HTMLImageElement;
            if (!isAbsolute(img.getAttribute('src'))) {
                img.setAttribute('src', `${window.location.origin}${img.getAttribute('src')}`);
            } else {
                img.setAttribute('src', `${img.getAttribute('src')}`); // forcing absolute url
            }
        });

        const stylesheetLink = this.popout.document.createElement('link') as HTMLLinkElement;
        stylesheetLink.href = `${window.location.origin}/ResourcePackages/infbredesign/assets/dist/main.css`;
        stylesheetLink.type = 'text/css';
        stylesheetLink.rel = 'stylesheet';
        stylesheetLink.media = 'screen,print';
        stylesheetLink.onload = () => {
            window.setTimeout(() => {
                this.popout.print();
                this.popout.onfocus = () => this.closePopout();
            }, 1000); //timeout because IE is dumb and spits out a blank piece of paper otherwise
        };

        this.popout.document.title = 'Print My Membership Card';
        this.popout.document.head.appendChild(stylesheetLink);
        this.popout.document.body.appendChild(card);
    }

    private closePopout = (): void => {
        if (this.popout) {
            this.popout.close();
        }
        this.popout = null;
    }
}